import React from 'react';
import merge from 'classnames';

import { Status } from './Status';

import styles from './ContentCard.module.scss';

export type Props = {
  title: string;
  status?: ReturnType<typeof Status>;
  classes?: Partial<{
    container: string;
    title: string;
  }>;
};

export const Header = ({ title, status, classes = {} }: Props) => (
  <section className={merge(styles.header, classes.container)} data-testid="header-wrapper">
    <h2 className={classes.title}>{title}</h2>
    {status}
  </section>
);
